import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { useApp } from 'containers/Bootstrap'
import { UserOut } from 'lib/apiClient'
import { AuthPayloadParam } from 'lib/auth'

export function useAppInitializer() {
  const [loading, setLoading] = useState(true)

  const { authService } = useApp()

  const [, setSearchParams] = useSearchParams()

  useEffect(
    function init() {
      const handleUserUpdate = (user: UserOut) => {
        setLoading(!user)
      }

      authService.subscribe(handleUserUpdate)

      authService.signIn().then(() => {
        setSearchParams(
          params => {
            Object.values(AuthPayloadParam).forEach(param => {
              params.delete(param)
            })

            return params
          },
          {
            replace: true,
          },
        )
      })

      return () => {
        authService.unsubscribe(handleUserUpdate)
      }
    },
    [authService, setSearchParams],
  )

  return {
    loading,
  }
}
